import axios from 'axios';
import weatherIcon from '@/assets/dataVisual/weatherIcon';

export let weatherApi = {
  methods: {
    /** 获取经纬度 */
    getLocation () {
      let citysearch = new AMap.CitySearch();
      citysearch.getLocalCity((status, result) => {
        console.log('getLocalCity', status, result);
        const city = result.city;
        if (status === 'complete' && result.info === 'OK' && city) {
          axios.get('https://geoapi.qweather.com/v2/city/lookup', { // 和风城市信息查询接口
            params: { location: city, key: this.weatherKey }
          }).then(({ data }) => {
            const location = data.location;
            console.log('lookup: ', location);
            if (location && Array.isArray(location) && location.length) {
              this.lngLat = [location[0].lon, location[0].lat].join();

              this.getForecastData();
              this.forecastUpdate();
              this.getNowWeather();
              this.nowUpdate();
            }
          });
        }
      });
    },
    /* 获取3天气预报 */
    getForecastData () {
      axios.get('https://devapi.qweather.com/v7/weather/3d', {
        params: {
          location: this.lngLat,
          key: this.weatherKey
        }
      }).then((res) => {
        let data = res.data.daily;
        data && data.length ? this.isGetData = true : this.isGetData = false;
        data.forEach((ele, index) => {
          ele.icon = weatherIcon['png' + ele.iconDay];
          ele.tmpTxt = `${ele.tempMax}/${ele.tempMin}℃`;
          if (index === 0) {
            ele.dayTxt = '今天';
          } else {
            ele.dayTxt = this.weekArr[new Date(ele.fxDate).getDay()];
          }
        });

        this.$store.commit('setForecast', data);
      });
    },
    /* 获取实况天气 */
    getNowWeather () {
      axios.get('https://devapi.qweather.com/v7/weather/now', {
        params: {
          key: this.weatherKey,
          location: this.lngLat
        }
      }).then(({data}) => {
        let nowWeather = data.now;
        if (nowWeather && Object.keys(nowWeather).length) {
          let date = data.updateTime;
          let dateTxt = date.split('T')[0].split('-').join('/');
          let week = this.weekArr[new Date(date).getDay()];
          nowWeather.icon = weatherIcon['png' + nowWeather.icon];
          this.$store.commit('setDateDetail', { week, dateTxt }); // 星期、年月日
          this.$store.commit('setNowWeather', nowWeather);
        }
      });
    }
  }
};
